const SHIPPOP = 'shippop'
const MASTER = 'master'
const SUPERADMIN = 'superadmin'
const ADMIN = 'admin'
const MEMBER = 'member'
let userDetails = null
const userLogin = {
    get(){

        let user = this.loadCurrentUser()

        if( user == false ){
            return null
        }

        return {
            details: userDetails,
            isShippop: this.isShippop(),
            isMaster: this.isMaster(),
            isSuperadmin: this.isSuperadmin(),
            isAdmin: this.isAdmin(),
            isMember: this.isMember(),
            isUnderByShippop: this.isUnderByShippop(),
        }
        
    },
    loadCurrentUser(){
        return userDetails = JSON.parse( localStorage.getItem('user') )
    },
    isShippop() {
        return userDetails.role == SHIPPOP
    },
    isMaster() {
        return userDetails.role == MASTER
    },
    isSuperadmin() {
        return userDetails.role == SUPERADMIN
    },
    isAdmin() {
        return userDetails.role == ADMIN
    },
    isMember() {
        return userDetails.role == MEMBER
    },
    isUnderByShippop(){
        return userDetails.under_by == SHIPPOP
    }
    
}


export default userLogin;